import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_READ_ONLY } = ROLES;

const ALLOWED_ROLES_EDIT_COMPANY_INFORMATION = [ROLE_OWNER, ROLE_ADMINISTRATOR];

const ALLOWED_ROLES_VIEW_COMPANY_INFORMATION = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_READ_ONLY];

export function canEditCompanyInformation(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_EDIT_COMPANY_INFORMATION);
}

export function canViewCompanyInformation(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_VIEW_COMPANY_INFORMATION);
}
